<template>
  <AgGridRenderList
    :columnDefs="columnDefs"
    :rowData="rowData"
    :totalRows="totalRows"
    :lastPage="lastPage"
    @grid-ready="onGridReady"
    @selection-changed="onSelectionChanged"
    :loading="paginationLoading"
    @updatePagination="updatePagination"
    @updateItemPerPage="updateItemPerPage"
  />
</template>

<script>
import General from "../../../../../../Mixins/general";

export default {
  components: {},
  props: {
    callRefresh: {
      type: Boolean,
      default: false,
    },
    callGroupDelete: {
      type: Boolean,
      default: false,
    },
    callDelete: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedIds: [],
      rowObject: null,
      columnDefs: null,
      rowData: null,
      totalRows: null,
      lastPage: null,
      invoiceIds: null,
      filterDialog: false,
      toDate: null,
      optionsNew: {
        page: 1,
        itemsPerPage: 10,
      },
      account: null,
      sellStatus: null,
      currencyFilter: null,
      fromAmount: null,
      fromNumber: null,
      fromDate: null,
      toAmount: null,
      toNumber: null,
      toDate: null,
      tag: null,
      category: null,
      branch: null,
      entrepot: null,
      lockStatus: null,
      registerar: null,
      payedStatus: null,
      fromTime: null,
      toTime: null,
      customFields: null,
      paginationLoading: false,
    };
  },
  mixins: [General],
  mounted() {
    this.columnDefs = [
      {
        headerName: "",
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 50,
        maxWidth: 50,
        minWidth: 50,
        cellRenderer: "AgVMenu",
        cellRendererParams: (params) => ({
          items: [
            {
              label: this.$t("edit"),
              icon: "mdi-pencil",
              iconColor: "gray",
              action: (rowData) => this.editAction(rowData),
            },
            {
              label: this.$t("delete"),
              icon: "mdi-trash-can-outline",
              iconColor: "gray",
              action: (rowData) => this.deleteActionPermission(rowData),
            },
          ],
        }),
        resizable: false,
        pinned: "right",
      },
      {
        headerName: "#",
        colId: "rowNumber",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 70,
        maxWidth: 70,
        minWidth: 70,
        resizable: false,
        pinned: "right",
      },
      {
        headerName: this.$t("workshopName"),
        field: "name",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.name && params.data.name !== null) {
            return params.data.name;
          } else {
            return this.$t("haveNot");
          }
        },
        filterParams: {
          closeOnApply: true,
          buttons: ["apply", "reset"],
          debounceMs: 0,
        },
        minWidth: 400,
        maxWidth: 500,
        sortable: true,
      },
      {
        headerName: this.$t("CoFunder"),
        field: "employer_name",
        // filter: "agNumberColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.employer_name) {
            return "#" + params.data.employer_name;
          } else {
            return this.$t("haveNot");
          }
        },
        sortable: true,
      },
      {
        headerName: this.$t("countPersonnel"),
        field: "employee_count",
        // filter: "agNumberColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.employee_count) {
            return params.data.employee_count;
          } else {
            return this.$t("haveNot");
          }
        },
        sortable: true,
      },
      {
        headerName: this.$t("workshopCode"),
        field: "insurance_code",
        // filter: "agNumberColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.insurance_code) {
            return params.data.insurance_code;
          } else {
            return 0;
          }
        },
        sortable: true,
      },
      {
        headerName: this.$t("rowContrat"),
        field: "contract_row",
        width: 168,
        // filter: "agNumberColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.contract_row) {
            return params.data.contract_row;
          } else {
            return 0;
          }
        },
        resizable: true,
        sortable: true,
      },
    ];
  },
  computed: {
    // payedStatuses() {
    //   return [
    //     { label: this.$t("payed"), value: "payed" },
    //     { label: this.$t("not-payed"), value: "notPayed" },
    //   ];
    // },
  },
  watch: {
    callGroupDelete: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.deletegroupAction();
        }
      },
    },
    callDelete: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.deleteAction();
        }
      },
    },
    callRefresh: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.getItems();
          this.$emit("initial-Loading-is", false);
        }
      },
    },
  },
  beforeMount() {
    this.getItems();
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onSelectionChanged(rows) {
      const ids = rows.map((r) => r.id);
      if (ids.length > 1) {
        this.selectedIds = ids;
        this.$emit("group-delete", true);
      }
    },
    getItems(isPaginate = false) {
      var app = this;
      if (!isPaginate) {
        app.$emit("initial-Loading-is", true);
      }
      this.paginationLoading = isPaginate;
      app.$axios
        .get(app.$endpoint + "workshop", {
          params: {
            options: app.optionsNew,
          },
        })
        .then((response) => {
          app.rowData = [...response.data.data];
          app.totalRows = response.data.total;
          app.lastPage = response.data.last_page;
          app.$emit("workshop-items", {
            items: response.data,
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("initial-Loading-is", false);
          app.$emit("call-refresh");
          app.paginationLoading = false;
        });
    },
    refreshData() {
      this.getItems(true);
    },
    updatePagination(value) {
      this.optionsNew.page = value;
      this.getItems(true);
    },
    updateItemPerPage(value) {
      this.optionsNew.itemsPerPage = value;
      this.optionsNew.page = 1;
      this.getItems(true);
    },
    editAction(rowData) {
      this.$router.push({
        name: "workshop_edit",
        params: { id: rowData.id, tabName: rowData.id },
      });
    },
    deleteActionPermission(rowData) {
      this.$emit("open-dialog-permision", true);
      this.rowObject = rowData;
    },
    deleteAction() {
      var app = this;
      let workshopId = app.rowObject.id;
      app.$axios
        .delete(app.$endpoint + "workshop/" + workshopId)
        .then((response) => {
          app.$emit("close-dialog-permision");
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("close-dialog-permision");
          app.getItems(true);
          app.paginationLoading = false;
        });
    },
    deletegroupAction() {
      var app = this;
      app.loading = true;
      let ids = app.selectedIds;
      app.$axios
        .delete(app.$endpoint + "workshop/0", {
          params: { deleteItems: ids },
        })
        .then((res) => {
          app.selectedIds = [];
          app.$emit("close-dialog-permision");
          app.getItems(true);
        })
        .catch((err) => {
          app.$emit("close-dialog-permision");
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          app.selectedIds = [];
          app.$emit("close-dialog-permision");
          app.getItems(true);
          app.paginationLoading = false;
        });
    },
  },
};
</script>

<style>
.wrapperTable {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.v-skeleton-loader__list-item.v-skeleton-loader__bone {
  align-content: unset;
  align-items: flex-start;
  padding: 0;
}
.theme--light.v-skeleton-loader .v-skeleton-loader__text {
  background: rgb(146 139 139 / 12%);
}
.v-skeleton-loader__text {
  height: 30px;
}
.v-skeleton-loader__list-item {
  height: 41px;
}
</style>
